import React from "react";
import styled from "styled-components/macro";
import { addLogoString } from "../../../helpers";

const BadgeWrapper = styled.div`
  background-color: white;
  padding: 10px;
  border-radius: 14px;
  box-shadow: 1px 1px 3px 1px gainsboro;
  border: 1px solid #eeeeee;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100px;
`;

const BadgeImage = styled.img`
  height: 100px;
  width: 100px;
  max-height: 82px;
  max-width: 82px;
  border-radius: 25px;
  object-fit: contain;
`;

const ShowBadge = ({ badge, nextLevels }) => {
  const nextLevel = nextLevels[badge.achievement_code];
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        minWidth: 240,
        flexDirection: "column",
        boxShadow: "0px 0px 3px 1px lightgray",
        borderRadius: 16,
        background: "white",
      }}
    >
      <div
        style={{
          padding: "16px 8px 12px 8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
        }}
      >
        <BadgeWrapper>
          <BadgeImage src={addLogoString(badge.achievement_level_image)} />
        </BadgeWrapper>
        <span style={{ fontSize: 16, fontWeight: 600 }}>
          {badge.achievement_name}
        </span>
      </div>
      <div style={{ width: "100%", height: 1, background: "lightgray" }} />

      <span style={{ fontSize: 12, color: "darkgrey", padding: 8 }}>
        {badge.achievement_descriptions.english}
      </span>
      <div style={{ width: "100%", height: 1, background: "lightgray" }} />
      <div style={{ padding: 8, display: "flex", flexDirection: "column" }}>
        <span>🎉</span>
        <span style={{ fontWeight: 700, fontSize: 13, color: "seagreen" }}>
          Level {badge.achievement_level_level} Completed
        </span>
        <span
          style={{
            color: "slategrey",
            fontWeight: 400,
            fontSize: 12,
          }}
        >
          {badge.achievement_level_descriptions.short_description.english}
        </span>

        <div style={{ minHeight: 0 }} />
      </div>
      <div style={{ width: "100%", height: 1, background: "lightgray" }} />
      <div style={{ padding: 8, display: "flex", flexDirection: "column" }}>
        <span>🎯</span>
        <span style={{ fontSize: 13, fontWeight: 700, color: "black" }}>
          Next Level
        </span>
        <span
          style={{
            color: "slategrey",
            fontWeight: 400,
            fontSize: 12,
          }}
        >
          {nextLevel?.descriptions?.requirements_description?.english ||
            "All Levels Achieved"}
        </span>
      </div>
      <div style={{ minHeight: 8 }} />
    </div>
  );
};

export default ShowBadge;
